import { useEffect, useRef } from "react";


export default function useInterval(callback:() => void, delay: any) {
    const savedCallback = useRef<(() => void) | null>(null);
    
    // Save the callback into the ref (always latest callback)
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval
    useEffect(() => {
        function tick() {
          if (savedCallback.current) {
            savedCallback.current();
          }
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id); // cleanup
        }
    }, [delay]);
  }
